import React from 'react';
import Hero from './Hero';
import About from './About';
import Skills from './Skills';
import Qualification from './Qualification';
import Services from './Services';
import Projects from './Projects';
import Contact from './Contact';

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <Skills />
      <Qualification />
      <Services />
      <Projects />
      <Contact />
    </>
  );
};

export default Home; 